import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { ApiEndpoints } from '../../shared/services/ApiEndpoints';
import { SharedMethods } from '../../shared/services/sharedMethods-service';


@Component({
  selector: 'app-main-carousel',
  templateUrl: './main-carousel.component.html',
  styleUrls: ['./main-carousel.component.scss']
})
export class MainCarouselComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() slides: Array<any> = [];

  public config: SwiperConfigInterface = {};

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true
  };

  constructor(public apiEndpoints: ApiEndpoints, public sharedMethods: SharedMethods) {

    /* if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        this.sharedMethods.cacheSettings = setting;
        this.slides = this.sharedMethods.cacheSettings.slides;
      });

    } else {

      this.slides = this.sharedMethods.cacheSettings.slides;

    } */


  }


  ngOnInit() {


    if(this.sharedMethods.cacheSettings !== undefined) {

      this.slides = this.sharedMethods.cacheSettings.slides;

    }

  }


  // tslint:disable-next-line:max-line-length
  // on Définit une méthode ngOnChanges () pour gérer les modifications. methode appéle lorsque toute propriété liée aux données d'une directive change.
  ngOnChanges(changes: SimpleChanges) {

      // lorsque le tableau de slide change on refraichir le slide
      this.ngAfterViewInit();

      // this.doSomething(changes.categoryId.currentValue);
      // You can also use categoryId.previousValue and 
      // categoryId.firstChange for comparing old and new values

      // la solution alternative est de transformer la proprieté en setter et getter
      /*
       private _categoryId: string;

       @Input() set categoryId(value: string) {

          this._categoryId = value;
          this.doSomething(this._categoryId);

        }

        get categoryId(): string {

            return this._categoryId;

        }
      */

  }

  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: true,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: false,
      preloadImages: true,
      lazy: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true
      },
      speed: 500,
      effect: 'slide'
    }

  }




}
